import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { createBlog } from "store/blogSlice";
import { useHistory } from "react-router-dom";
import { quillModules } from "./quillConfig";

export default function BlogCreate({color}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState("");
  const [slug, setSlug] = useState("");
  const [isPublished, setIsPublished] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("slug", slug);
    formData.append("description", description);
    formData.append("is_published", isPublished);
    if (image) formData.append("image", image);

    dispatch(createBlog(formData)).then(() => {
      history.push("/admin/blog");
    });
  };

  return (
    <div
      className={
        "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
        (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
      }
    >
      <div className="max-w-5xl mx-auto p-6 bg-white shadow rounded">
        <h2 className="text-xl font-semibold mb-4">Create Blog</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="block text-sm font-medium mb-1">Title</label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div>
    <label className="block text-sm font-medium mb-1">Slug</label>
    <input
      type="text"
      className="w-full border px-3 py-2 rounded"
      value={slug}
      onChange={(e) => setSlug(e.target.value)}
      placeholder="example-blog-slug"
      required
    />
  </div>


          {/* Image */}
          <div>
            <label className="block text-sm font-medium mb-1">Image</label>
            <input
              type="file"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Description
            </label>
            <ReactQuill
              theme="snow"
              value={description}
              onChange={setDescription}
              modules={quillModules}
              className="bg-white"
            />
          </div>

          {/* Published */}
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={isPublished}
              onChange={(e) => setIsPublished(e.target.checked)}
            />
            <label>Is Published</label>
          </div>

          {/* Buttons */}
          <div className="flex space-x-2">
            <button
              type="submit"
              className="bg-lightBlue-600 text-white px-4 py-2 rounded"
            >
              Create
            </button>
            <button
              type="button"
              onClick={() => history.push("/admin/blog")}
              className="bg-gray-300 px-4 py-2 rounded"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

BlogCreate.defaultProps = {
  color: "light",
};

BlogCreate.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
